<template>
  <div>
    <h5>{{ title }}</h5>
    <div class="block">
      <el-date-picker
        ref="picker"
        style="width: 100%"
        v-model="dateRange"
        type="datetimerange"
        range-separator="To"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="Start Date"
        end-placeholder="End Date"
        :picker-options="pickerOptions"
        format="dd-MM-yyyy HH:mm:ss"
        @input="handleChange"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { get } from 'lodash';

export default {
  name: 'DateRangeFilter',
  data: () => ({
    dateRange: null,
    pickerOptions: {
      shortcuts: [
        {
          text: 'Last month',
          onClick(picker) {
            const startDate = moment()
              .startOf('day')
              .subtract('month', 1)
              .toDate();
            const endDate = moment()
              .endOf('day')
              .toDate();
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: 'Last 3 Months',
          onClick(picker) {
            const startDate = moment()
              .startOf('day')
              .subtract('month', 3)
              .toDate();
            const endDate = moment()
              .endOf('day')
              .toDate();
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: 'Last 6 Months',
          onClick(picker) {
            const startDate = moment()
              .startOf('day')
              .subtract('month', 6)
              .toDate();
            const endDate = moment()
              .endOf('day')
              .toDate();
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: 'Last Year',
          onClick(picker) {
            const startDate = moment()
              .startOf('year')
              .subtract('year', 1)
              .toDate();
            const endDate = moment()
              .endOf('year')
              .subtract('year', 1)
              .toDate();
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: 'This Year',
          onClick(picker) {
            const startDate = moment()
              .startOf('year')
              .toDate();
            const endDate = moment()
              .endOf('year')
              .toDate();
            picker.$emit('pick', [startDate, endDate]);
          },
        },
      ],
    },
  }),
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    apply(filter) {
      const dates = get(filter, 'meta.engagement', []);
      this.dateRange = dates;
    },
    reset() {
      this.dateRange = null;
      this.handleChange();
    },
    handleChange(dates) {
      this.dateRange = dates;

      const localDates = dates
        ? dates.map(date =>
            moment(date)
              .local()
              .format(),
          )
        : null;
      this.$emit('change', ['meta.engagement', localDates]);
    },
  },
};
</script>

<style scoped>
h5 {
  color: #c2c5cc;
}
</style>



// WEBPACK FOOTER //
// DateRangeFilter.vue?40c79629